import * as React from "react";
const SvgIcon49 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21.604 21.604" {...props}><path d="m1.4 19.267 4.334-.888.323.167a9.271 9.271 0 1 0-3.84-3.708l.2.357L1.4 19.267Zm.207 1.01A1.03 1.03 0 0 1 .4 19.017l.917-3.674a10.3 10.3 0 1 1 4.263 4.118l-3.98.815Z" transform="translate(.5 .5)" style={{
    fill: "var(--primaryIconButtonTextColor,#fff)",
    stroke: "var(--primaryIconButtonTextColor,#fff)"
  }} /></svg>;
export default SvgIcon49;